import { Stack, Image, ImageFit } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/collectie.module.scss';
import { IReview, TReview } from '../constants/types';
import HeaderInfoComponent from './headerInfoComponent';
import GlobalContext from '../_contexts/GlobalContext';

export interface ICarouselComponentProps {
    isDev: boolean;
    animationsEnabled: boolean;
}

const CarouselComponent : React.FunctionComponent<ICarouselComponentProps> = (props : ICarouselComponentProps) => {
    const [reviews, setreviews] = useState<TReview[]>([]);
    const [fading, setfading] = useState<string>(styles.elementToFadeIn);
    const [average, setaverage] = useState<number>(10);
    const [count, setcount] = useState<number>(0);
    const [percTillNext, setpercTillNext] = useState<number>(0);
    const [startSwipe, setstartSwipe] = useState<number>(0);
    const [endSwipe, setendSwipe] = useState<number>(0);

    const { CAROUSEL_PROMO_SET_ID, Reviews, GlobalImagesVersion, NO_REVIEWS_URLS } = useContext(GlobalContext);

    useEffect(() => {
        heartBeat();

        let reviews: IReview[] = [];
        if (Reviews.reviews?.length > 0) {
            Reviews.reviews.sort((a,b) => new Date(a.date) > new Date(b.date) ? -1 : 1);
            CAROUSEL_PROMO_SET_ID ? reviews.push({id:-2, comment:"", date:null, name:"", stars:10}) 
                                                : reviews.push(Reviews.reviews[Reviews.reviews.length-1]);
        } else {
            reviews.push({id: 0, content:NO_REVIEWS_URLS[0], comment: "", date:null, name: "", stars:0});
        }
        
        reviews.push({id:-1, comment:"", date:null, name:"", stars:10, child: <HeaderInfoComponent />});
        
        for (let i=0,l=Reviews?.reviews?.length-1; i<l; i++) {
            reviews.push(Reviews.reviews[i]);
        }

        if (reviews.length < 6) {
            let j=1;
            for (let i=reviews.length+1; i<7; i++) {
                reviews.push({id: 0, content:NO_REVIEWS_URLS[j], comment: "", date:null, name:"", stars:0});
                j++;
            }
        }

        let average = Math.round(Reviews.average*10) / 10;
        setreviews(reviews);
        setaverage(average);
        setcount(Reviews.count);        
    },[]);

    useEffect(() => {
        if (props.animationsEnabled) {
            setpercTillNext(0);
            heartBeat();
        }
    }, [props.animationsEnabled]);

    function heartBeat() {
        if (props.animationsEnabled) {
            setpercTillNext(percTillNext + 10);
            setTimeout(() => {
                if (percTillNext + 10 >= 100) {
                    setOrder();
                } else {
                    heartBeat();
                }
            }, 1000);
        }
    }

    function setOrder() {
        if (props.animationsEnabled) {
            let newreviews : TReview[] = [];
            for (let i=1; i<reviews.length; i++) {
                newreviews.push(reviews[i]);
            }
            newreviews.push(reviews[0]);
            setfading(styles.moveLeft);
            setTimeout(() => {
                setreviews(newreviews);
                setfading(styles.elementToFadeIn);
                setpercTillNext(0);
                heartBeat();
            }, 1000);
        }
    }

    function nextReview() {
        if (fading === styles.elementToFadeIn) {
            setfading(styles.moveLeft);
            setpercTillNext(0);
            setTimeout(() => {
                setfading(styles.elementToFadeIn);
                setpercTillNext(0);
                setreviews(cycleNextReview(reviews));
            }, 1000);
        }
    }

    function previousReview() {
        if (fading === styles.elementToFadeIn) {
            setfading(styles.moveRight);
            setpercTillNext(0);
            setTimeout(() => {
                setfading(styles.elementToFadeIn);
                setpercTillNext(0);
                setreviews(cycleNextReview(reviews, true));
            }, 1000);
        }
    }

    function cycleNextReview(_reviews: IReview[], previous: boolean = false) : IReview[] {
        let newreviews : IReview[] = [];
        if (previous) {
            newreviews.push(_reviews[_reviews.length-1]);
            for (let i=0; i<_reviews.length-1; i++) {
                newreviews.push(_reviews[i]);
            }
        } else {
            for (let i=1; i<_reviews.length; i++) {
                newreviews.push(_reviews[i]);
            }
            newreviews.push(_reviews[0]);
        }
        return newreviews;
    }

    function swipeEnd(e) {
        if (startSwipe != -1 && endSwipe != -1) {
            if ((endSwipe - startSwipe) > 40) {
                previousReview();
            } else if ((startSwipe - endSwipe) > 40) {
                nextReview();
            }
            setstartSwipe(-1);
            setendSwipe(-1);
        }
    }

    return (
        <div style={{maxWidth:"100%"}}>
            {reviews?.length > 0 &&
                <Stack horizontal>
                    <Stack verticalAlign='center' horizontalAlign='start'>
                        <Image {...{imageFit: ImageFit.centerContain,
                                    className: styles.previousReview,
                                    src: `${process.env.PUBLIC_URL}/assets/previoussmall.webp?v=${GlobalImagesVersion}`,
                                    styles: props => ({ root: { margin: 0, zIndex: 1} }),
                                    onClick: () => { previousReview(); }
                                }} alt="" />
                    </Stack>
                    <div style={{maxWidth:"100%",paddingLeft:5}} 
                            onTouchStart={(e) => { setstartSwipe(e.targetTouches[0].clientX); }}
                            onTouchMove={(e) => { setendSwipe(e.targetTouches[0].clientX); }}
                            onTouchEnd={swipeEnd}>
                        <ReviewComponent reviews={reviews} average={average} fading={fading} count={count}/>
                    </div>
                    <Stack verticalAlign='center' horizontalAlign='end'>
                        <div className={styles.progressbar} style={props.animationsEnabled ? {background:`radial-gradient(closest-side, transparent, transparent 80% 100%), conic-gradient(lightblue ${percTillNext}%, transparent 0)`} : {}}>
                            <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.nextReview,
                                        src: `${process.env.PUBLIC_URL}/assets/nextsmall.webp?v=${GlobalImagesVersion}`,
                                        styles: props => ({ root: { margin: 0, zIndex: 1} }),
                                        onClick: () => { nextReview(); }
                                    }} alt="" />
                        </div>
                    </Stack>
                </Stack>
            }
        </div>
    );
}

class ReviewComponent extends React.Component<any, any> { //TODO
    constructor(props: ICarouselComponentProps) {
        super(props);
    }

    public render(): React.ReactElement<ICarouselComponentProps> {

        return (
            <div>
                <Stack horizontal tokens={{childrenGap: 5, padding: 5}} style={{marginLeft:-305,overflow:"hidden"}}>
                    {this.props.reviews.map(review => {
                        return review.child ? 
                        <Stack horizontalAlign='center' horizontal={false} className={`${styles.aPanel} ${this.props.fading} ${styles.reviewComponent}`} style={{overflow:"hidden"}}>
                            {review.child}
                        </Stack> :  review.content ? <Stack horizontal={false} horizontalAlign='center' verticalAlign='end' style={{paddingBottom:0}} className={`${styles.aPanel} ${this.props.fading} ${styles.reviewComponent}`}>
                                                        <Stack className={styles.carouselContent} horizontalAlign='center' verticalAlign='center'>
                                                            <img src={review.content.Image} onClick={() => { window.open(review.content.URL, '_blank').focus(); }}/>
                                                        </Stack>
                                                     </Stack> 
                                                   : review.id === -2 ?
                                                        <Stack horizontal={false} horizontalAlign='center' verticalAlign='end' style={{paddingBottom:0}} className={`${styles.aPanel} ${this.props.fading} ${styles.reviewComponent}`}>
                                                            <div className={styles.carouselPromo}></div>
                                                        </Stack>
                                                     :  <Stack className={`${styles.aPanel} ${this.props.fading} ${styles.reviewComponent}`} style={{overflow:"hidden",paddingLeft:5}}>
                                                            <Stack horizontal horizontalAlign='start' style={{height:"100%"}}>
                                                                <div className={styles.bPanel} style={{whiteSpace:"nowrap",height:25, backgroundColor:"lightgray"}}>
                                                                    <Stack horizontal>
                                                                        <span style={{color:"rgb(110,110,110)",float:"right"}}>{review.stars}</span>
                                                                        <span style={{fontSize:"smaller"}}>/10&nbsp;</span>
                                                                    </Stack>
                                                                </div>
                                                                <p className={styles.reviewText}>{review.comment}</p>
                                                            </Stack>
                                                            <Stack horizontal verticalAlign='end' horizontalAlign='end'>
                                                                <i style={{color:"darkgray",paddingRight:"5px"}}>{review.name}</i>
                                                            </Stack>
                                                        </Stack>
                    })}
                </Stack>
            </div>
        );
    }
}

export default CarouselComponent;